import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false
    },
    datalabels: {
      display: true,
      clamp: false,
      color: 'black',
      anchor: 'end',
      align: 'end',
      font: {
        weight: 'bold'
      }
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
    },
    y: {
      grid: {
        display: false
      },
      ticks: {
        stepSize: 1
      }
    }
  }
};

const labels: string[] = ['L', 'M', "M", 'J', 'V', 'S', 'D']

const formatData = (count) => {
  const list: number[] = []
  const today = new Date()
  const start = moment(new Date(today.setDate(today.getDate() - today.getDay() + 0))).startOf("day");
  const end = moment(new Date(today.setDate(today.getDate() - today.getDay() + 7))).startOf("day");

  let result: string[] = []

  if (count?.count === 0 || count === 'ERR_NETWORK') return {
    labels,
    datasets: [{
      data: [],
      backgroundColor: ["#5d5fef"],
      borderWidth: 0,
      borderRadius: 3,
    }]
  }

  while (start.add(1, 'days').diff(end) <= 0) {
    result.push(start.clone().format("YYYY-MM-DD"));
  }

  result.forEach((elem) => {
    const found = count?.find((i: { _id: string }) => i._id === elem)
    if (found) {
      list.push(found.count)
    } else {
      list.push(0)
    }
  })

  return {
    labels,
    datasets: [{
      data: list,
      backgroundColor: ["#5d5fef"],
      borderWidth: 0,
      borderRadius: 3,
    }]
  }
}

const WeeklyChart = (props: { count: { _id: string, count: number } }) => (
  <Bar
    plugins={[ChartDataLabels]}
    options={options}
    data={formatData(props.count)}
  />
)

export default WeeklyChart